module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Tips_Form":{"hooks.onStartAddedToDom":[{"value":function() {
var counterCalls = 0;
var tipsForm = this;
var callback = function() {
counterCalls++;
if (typeof _gaLinkerLoaded === 'undefined' || !_gaLinkerLoaded && counterCalls < 5) {
setTimeout(arguments.callee, 2000);
return;
}
var linkerParam = fox.wom.selectFirst('@root #googleAnalytics').getLinkerParam();
if (linkerParam) {
tipsForm.setOption('preparedTransactionParams', { 'transitParams[_ga]': linkerParam});
}
}();
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"~.Tips_Form","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/tipsForm.js
// module id = 737
// module chunks = 4